export default "__VITE_ASSET__B8I4a6Ic__"